<div fxLayout="row" fxLayoutAlign="start start" class="sidebar-container">
  <div fxFlex="100" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="41px">

    <div fxFill class="nav-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" routerLink="analytics" routerLinkActive="active">
      <mat-icon class="material-icons material-icons-outlined">insert_chart_outlined</mat-icon>
      <span>Dashboard</span>
    </div>

    <div routerLink="/admin/courses" routerLinkActive="active"  fxFill class="nav-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-icon class="material-icons material-icons-outlined">library_books</mat-icon>
      <span>Courses</span>
      <span fxFlex="auto" fxLayout="row" fxLayoutAlign="end center">
        <mat-icon class="material-icons">keyboard_arrow_right</mat-icon>
      </span>
    </div>

    <div *ngIf="user?.role === 'ADMIN'" routerLink="/admin/paths" routerLinkActive="active"  fxFill class="nav-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-icon class="material-icons material-icons-outlined">school</mat-icon>
      <span>Paths</span>
      <span fxFlex="auto" fxLayout="row" fxLayoutAlign="end center">
        <mat-icon class="material-icons">keyboard_arrow_right</mat-icon>
      </span>
    </div>

    <div *ngIf="user?.role === 'ADMIN'" routerLink="/translations" routerLinkActive="active"  fxFill class="nav-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-icon class="material-icons material-icons-outlined">language</mat-icon>
      <span>Translations</span>
      <span fxFlex="auto" fxLayout="row" fxLayoutAlign="end center">
        <mat-icon class="material-icons">keyboard_arrow_right</mat-icon>
      </span>
    </div>

    <!-- <div fxFill class="nav-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-icon class="material-icons material-icons-outlined">settings</mat-icon>
      <span>Settings</span>
      <span fxFlex="auto" fxLayout="row" fxLayoutAlign="end center">
        <mat-icon class="material-icons">keyboard_arrow_right</mat-icon>
      </span>
    </div>

    <div fxFill class="nav-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <mat-icon class="material-icons material-icons-outlined">help_outline</mat-icon>
      <span>Help</span>
    </div> -->

  </div>
</div>
